import React from 'react';
import styled from 'styled-components';
import { Breakpoints } from 'kinedu-react-components';
import { educadoresLogo, educatorsLogo, educatorsLogoWhiteEn, educatorsLogoWhitePt, educatorsLogoWhiteEs } from '../../constants/general';

interface ClassroomsLogoProps {
  alt?: boolean;
  lang?: string;
  size?: number;
  mobileSize?: number;
  tabletSize?: number;
  desktopSize?: number;
}

const Image = styled.img.attrs((props) => ({ src: props.src }))`
  margin: 0px auto 10px;
  width: ${({ size, mobileSize }: ClassroomsLogoProps) => size ? `${size}px` : `${mobileSize}px`};

  ${Breakpoints.tablet} {
    width: ${({ size, desktopSize }: ClassroomsLogoProps) => size ? `${size}px` : `${desktopSize}px`};
  }

  ${Breakpoints.desktop} {
    width: ${({ size, desktopSize }: ClassroomsLogoProps) => size ? `${size}px` : `${desktopSize}px`};
  }
`;

const getLogoSrc = (alt: any, lang:string) => {
  const logosAlt:any = {
    es: educatorsLogoWhiteEs,
    en: educatorsLogoWhiteEn,
    pt: educatorsLogoWhitePt,
  };

  const logos:any = {
    es: educadoresLogo,
    en: educatorsLogo,
    pt: educadoresLogo,
  };

  return alt ? logosAlt[lang] : logos[lang];
};

const ClassroomsLogo: React.FC<ClassroomsLogoProps> = ({
  alt,
  size,
  lang = 'en',
  mobileSize = 128,
  tabletSize = 138,
  desktopSize = 400,
}) => (
  <Image
    src={getLogoSrc(alt, lang)}
    size={size}
    mobileSize={mobileSize}
    tabletSize={tabletSize}
    desktopSize={desktopSize}
  />
);

export default ClassroomsLogo;
